import { useVersionCheck } from '@/hooks/useVersionCheck';

export const VersionToast = () => {
  const { hasNewVersion } = useVersionCheck();

  if (!hasNewVersion) return null;

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 flex animate-fade-in items-center justify-between rounded-xl bg-gray-800 px-4 py-3 text-white shadow-lg md:right-auto md:max-w-md">
      <span>¡Hay una nueva versión disponible!</span>
      <button
        onClick={reloadPage}
        className="ml-4 rounded bg-white px-3 py-1 font-semibold text-gray-800 transition hover:bg-gray-200"
      >
        Actualizar
      </button>
    </div>
  );
};
